<template>
  <div :class="$style.gutterWrapper">
    <MaskController
      :class="[
        $style.gutterReversal,
        $style.harmonyShadow,
      ]"
      :collection-presenter="collectionPresenter"
    >
      <Collection
        ref="CollectionPresenter"
        :class="[
          $style.scroller,
          $style.overlaySrollArea,
          $style.invisibleScrollArea,
          $style.gutterScroller,

          alignmentClass,
          scrollSnapAlignClass,
        ]"
      >
        <slot />
      </Collection>
    </MaskController>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import MaskController from '@/scripts/Components/commons/presenters/collection-carousel/mask-controller.ts.vue';
import { AlignmentAdjustmentProvider } from '@/scripts/Components/commons/shared/alignment-adjustment-provider';
import Collection from './PageCollection.ts.vue';

export default Vue.extend({
  components: {
    MaskController,
    Collection,
  },
  props: {
    align: {
      type: String as PropType<'left' | 'center'>,
      default: 'left',
    },
  },
  data() {
    return {
      collectionPresenter: undefined as Vue | undefined,
      alignmentAdjustmentProvider: new AlignmentAdjustmentProvider(),
    };
  },

  computed: {
    alignmentClass(): string {
      if (this.alignmentAdjustmentProvider.isContentOverflowing) {
        return this.$style.scrollAreaContentOverflowing;
      }
      return this.$style.scrollAreaContentNotOverflowing;
    },
    scrollSnapAlignClass(): string {
      if (this.align === 'center') return this.$style.scrollSnapCenter;
      return this.$style.scrollSnapLeft;
    },
  },

  mounted(): void {
    if (this.align !== 'center') return;

    this.collectionPresenter = this.$refs.CollectionPresenter as Vue;
    this.alignmentAdjustmentProvider.mount(this.collectionPresenter.$el);
  },

  beforeDestroy(): void {
    this.alignmentAdjustmentProvider.destroy();
  },
});
</script>

<style lang="scss" module>
@import '../styles/variables-entry';

.invisibleScrollArea {
  // Remove scrollbar
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.overlaySrollArea {
  display: flex;
  overflow-x: auto;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.scrollSnap {
  scroll-snap-type: x proximity;

  &.scrollSnapCenter {
    > * {
      scroll-snap-align: center;
    }
  }
  &.scrollSnapLeft {
    > * {
      scroll-snap-align: left ;
    }
  }
}

.scrollAreaContentOverflowing {
  // Do nothing
}
.scrollAreaContentNotOverflowing {
  justify-content: center;
  &::after {
    display: none;
  }
}

// This section of CSS allow box-shadow to leak outside of the scroll area
.harmonyShadow {
  padding-top: 1px;
  margin-top: -1px;
  padding-bottom: 1px;
  margin-bottom: -1px;

  // TODO: Extravagant shadow-allowance is not working yet. Let's use a more conversative value for now...
  // .overlaySrollArea {
  //   $shadow-allowance: 96px;
  //   margin-top: -$shadow-allowance;
  //   margin-bottom: -$shadow-allowance;
  //   padding-top: $shadow-allowance;
  //   padding-bottom: $shadow-allowance;

  //   // Prevent the excessive margin to blocking other elements
  //   pointer-events: none;
  // }
  // .item {
  //   // Restore interaction for item
  //   pointer-events: auto;
  // }

  .overlaySrollArea {
    $shadow-allowance: 15px;
    margin-top: -$shadow-allowance;
    margin-bottom: -$shadow-allowance;
    padding-top: $shadow-allowance;
    padding-bottom: $shadow-allowance;
  }
}

.gutterWrapper {
  $padding: $grid-gutter-width / 2;

  &,
  .gutterScroller {
    padding-right: $padding;
    padding-left: $padding;
  }
  .gutterScroller {
    scroll-padding-right: $padding;
    scroll-padding-left: $padding;
    &::after {
      padding-left: $padding;
    }
  }
  .gutterReversal {
    margin-right: -1 * $padding;
    margin-left: -1 * $padding;
  }
}
</style>
